import { render, staticRenderFns } from "./live.vue?vue&type=template&id=431e4830&"
import script from "./live.vue?vue&type=script&lang=js&"
export * from "./live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports